/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_8_AInputs */

const en_mk_faq_8_a = /** @type {(inputs: Mk_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For supported automatic projects, you can see release status, restore a previous version, pause or wake the app, and export a ZIP. Review hosting limits and your project checklist before using it for production.`)
};

const id_mk_faq_8_a = /** @type {(inputs: Mk_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk proyek otomatis yang didukung, kamu dapat melihat status penerbitan, kembali ke versi sebelumnya, menjeda atau mengaktifkan aplikasi, dan mengekspor ZIP. Tinjau batas hosting dan daftar pemeriksaan proyek sebelum menggunakannya untuk kebutuhan produksi.`)
};

/**
* | output |
* | --- |
* | "For supported automatic projects, you can see release status, restore a previous version, pause or wake the app, and export a ZIP. Review hosting limits and ..." |
*
* @param {Mk_Faq_8_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_8_a = /** @type {((inputs?: Mk_Faq_8_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_8_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_8_a(inputs)
	return en_mk_faq_8_a(inputs)
});